module.exports = __webpack_public_path__ + "static/media/Allison Kuehner Headshot.998abcd0.jpeg";